<!-- eslint-disable no-unused-vars -->
<template lang="">
    <div class='fixed bg-color-red w-screen h-screen bg-site-secondary top-0 left-0 bg-opacity-70' >
       
     
      <div class='flex items-center justify-center h-full'>
        
         <FormKit type ='form' :actions="false"  id='addEntry' number='float' @submit="() => addEntry(componentsStore.showAddEntry._date) " >
        <v-icon class="icon flex self-end hover:cursor-pointer text-red-500" scale="1.5" name="io-close" @click='componentsStore.changeAddEntryForm'/>
          
            <FormKit type="text" label='Weight' :validation="[['matches', /^[^,]*$/], ['required'], ['number'] ]" number='float'  v-model='_weight' name='weight' validation-visibility="live"  :validation-messages="{
    matches: 'Only dots are allowed.' ,
  }" help='Use dots . if you want to write floats.'> </FormKit>

  <div v-if='(componentsStore.showAddEntry._date).length >= 2'>
    {{componentsStore.showAddEntry._date}}
  </div>
    <div class='flex justify-end'>
        <FormKit
        type="submit"
        label="Add Entry"
        />
         </div>
       
  
       </FormKit>
  </div>
      
      </div>
   

</template>
<script setup>
// eslint-disable-next-line no-unused-vars
import { addWeightEntry } from '@/services/UserService';
import { defineEmits, ref } from 'vue';


const emit = defineEmits(['refresh-event'])
import { MessageStore } from '@/stores/Messages';
// eslint-disable-next-line no-unused-vars
const messagesStore = MessageStore();
import {ComponentsStore} from '@/stores/ComponentsStore';
// eslint-disable-next-line no-unused-vars
const componentsStore = ComponentsStore();

const _weight = ref('');


// eslint-disable-next-line no-unused-vars
async function addEntry(date) {

 
    
    let _entry = [(_weight.value).toString(), date];

    const addEntry = await addWeightEntry(_entry);

    
    if(addEntry.boolean === true){
      
      messagesStore.setMessage(addEntry.message, true);
    }
    else if(addEntry.boolean === false){
      messagesStore.setMessage(addEntry.message, false);
    }
    emit('refresh-event')

}


</script>
<style lang="css"></style>